/**
 * All app routes
 */
export const enum Routes {
    market = 'market',
    wallet = 'wallet',
    swap = 'swap',
    buy = 'buy',
    staking = 'staking',
    history = 'history',
    send = 'send',
    cards = 'cards',
    receive = 'receive',
    transfer = 'transfer',
    asset = 'asset',
    signIn = 'sign-in',
    signUp = 'sign-up',
    chooseCountry = 'choose-country',
    verifyEmailSignUp = 'verify-email-sign-up',
    verifyEmailSignIn = 'verify-email-sign-in',
    verifyPhoneSignUp = 'verify-phone-sign-up',
    serviceNotAvailable = 'service-not-available',
    signInBlocked = 'sign-in-blocked',
    signUpSuccess = 'sign-up-success',
    twoFaCode = '2fa-code',
    passwordRecovery = 'password-recovery',
    passwordRecoveryCreation = 'password-recovery-creation',
    passwordRecoverySuccess = 'password-recovery-success',
    socialAuth = 'social-auth',
    inviteSocialAuth = 'invite-social-auth',
}

export const privateRoutes = [
    Routes.wallet,
    Routes.cards,
    Routes.history,
    Routes.staking,
    Routes.swap,
    Routes.buy,
    Routes.send,
    Routes.receive,
]

/**
 * All app query params
 */
export const enum QueryParams {
    type = 'type',
    action = 'action',
    cardId = 'card_id',
    toCurrency = 'to_currency',
    fromCurrency = 'from_currency',
    amount = 'amount',
    refId = 'ref_id',
    auth = 'auth',
    sync = 'sync',
    settings = 'settings',
    idp_login_state = 'idp_login_state',
    auth_token = 'auth_token',
    recipient = 'recipient',
    auth_screen = 'auth_screen',
    error = 'error',
    auth_source = 'auth_source',
    filter = 'filter',
    onlyFavorites = 'only_favorites',
    currency = 'currency',
    txType = 'tx_type',
    from = 'from',
    till = 'till',
    sumsubLevel = 'sumsubLevel',
    sort = 'sort',
    paymentId = 'paymentId',
    network = 'network',
}
